module.exports = __webpack_public_path__ + "img/mobicon.136404b1.png";